export default __webpack_public_path__ + "media/music/ad68cdf191bf61b67b21571892f9cba4.mp3";